import { ApiResponse } from "../../shared/api/types";
import {
  AnyReportConfigurationForRunning,
  Report,
  ReportAuthorizationInfo,
  TabularReportConfigurationForRunning,
} from "../../shared/reporting/api/biClient.types";

export const manageReportSwitching = (
  isSwitchingReport: boolean,
  setSwitchingReport: (v: boolean) => void,
  getReport: () => Promise<void>
) => {
  if (isSwitchingReport) {
    setSwitchingReport(true);
  }
  getReport().finally(() => {
    setSwitchingReport(false);
  });
};

export const getExistingReportWithAuth = async (
  getReport: () => Promise<ApiResponse<Report>>,
  getReportRunningData: (() => Promise<ApiResponse<AnyReportConfigurationForRunning>>) | undefined,
  getReportAuthorizationInfo: () => Promise<ApiResponse<ReportAuthorizationInfo>>,
  onReportNotFound: () => void,
  onReportFound: (report: Report, runningData: AnyReportConfigurationForRunning) => void,
  onSuccessfulAuthorization: (authorizationInfo: ReportAuthorizationInfo) => void
) => {
  try {
    const [reportResp, runningData, authorizationResp] = await Promise.all([
      getReport(),
      getReportRunningData?.() ?? Promise.resolve({ success: true, data: {} as TabularReportConfigurationForRunning }),
      getReportAuthorizationInfo(),
    ]);
    if (reportResp.success && reportResp.data !== undefined && runningData.success && runningData.data !== undefined) {
      onReportFound(reportResp.data, runningData.data);
    } else {
      onReportNotFound();
    }

    if (authorizationResp.success && authorizationResp.data !== undefined) {
      onSuccessfulAuthorization(authorizationResp.data);
    }
  } catch {
    onReportNotFound();
  }
};
